<template>
    <form @submit.prevent="profile">
			<div class="form_box">
				<table>
					<tr>
						<th>メールアドレス</th>
  				  <td><p><input type="text" v-model="email" required></p></td>
					</tr>
					<tr>
						<th>名前</th>
  					<td class="tow"><p><input type="text" v-model="familyName" required><input type="text" v-model="givenName" required></p></td>
					</tr>
					<tr>
						<th>電話番号</th>
  				  <td><p><input type="text" v-model="tel" required></p></td>
					</tr>
					<tr>
						<th>法人名</th>
  					<td><p><input type="text" v-model="companyName"></p></td>
					</tr>
          <id-addr ref="address" :zipcode="this.zipcode" :address="this.address" @updateAddress="updateAddress"></id-addr>
				</table>
				<p class="submit"><input type="submit" value="変更する"></p>
			</div>
		</form>
</template>

<script>
import Vue from 'vue'
import Address from './Address'
Vue.component('id-addr', Address)

export default {
  name: 'Profile',
  data () {
    return {
      email: '',
      familyName: '',
      givenName: '',
      companyName: '',
      tel: '',
      zipcode: '',
      address: '',
    }
  },
  mounted () {
    this.$cognito.getUserAttributes(['email', 'family_name', 'given_name', 'custom:company_name', 'custom:tel', 'address', 'custom:zipcode'])
      .then(attributes => {
         this.email = attributes['email']
         this.familyName = attributes['family_name']
         this.givenName = attributes['given_name']
         this.companyName = attributes['custom:company_name']
         this.address = attributes['address']
         this.tel = attributes['custom:tel']
         this.zipcode = attributes['custom:zipcode']
      })
  },
  methods: {
    profile () {
      this.$refs.address.update()
      this.$cognito.updateAttributes(this.email, this.familyName, this.givenName, this.companyName, this.tel, this.zipcode, this.address)
        .then(result => {
          this.$notify({ group: 'main', text: '更新しました。' })
          this.$router.replace('/home')
        })
        .catch(err => {
          this.$notify({ group: 'main', type: 'error', text: this.$i18n.t("message.profile." + err.code) })
        })
    },
    updateAddress (address, zipcode) {
      this.address = address
      this.zipcode = zipcode
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/user.css'
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue